/** Parses "15m", "10s", "1h" or plain milliseconds (same format as the production client). */
export function parseDuration(value: string | undefined, fallbackMs: number): number {
  const raw = value?.trim();
  if (!raw) return fallbackMs;
  if (/^\d+$/.test(raw)) return Number(raw);
  const match = /^(\d+)([smh])$/i.exec(raw);
  if (!match) return fallbackMs;
  const amount = Number(match[1]);
  const unit = match[2]?.toLowerCase();
  const factor = unit === 'h' ? 3_600_000 : unit === 'm' ? 60_000 : 1_000;
  return amount * factor;
}

// The previous client (and existing deployments' .env files) use the VITE_APP_* names; both are
// accepted so an unchanged .env keeps pointing at the right API.
export const env = {
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    import.meta.env.VITE_APP_API_BASE_URL ||
    'http://localhost:5555/api',
  /** Idle time before the logout warning appears (production default 15 minutes). */
  inactivityTimeoutMs: parseDuration(
    import.meta.env.VITE_INACTIVITY_TIMEOUT || import.meta.env.VITE_APP_INACTIVITY_TIMEOUT,
    15 * 60_000,
  ),
} as const;
